<template>
  <div>
    <div class="scrollbarOffset">
      <!-- //训练营养详情-->
      <div class="wrapBox">
        <div class="leftContent">
          <h3 class="leftContentTitle">{{ details.title }}</h3>
          <div class="titleContent">
            <div :title="details.keyword" class="titleKeyword textHidden">
              关键字：{{ details.keyword }}
            </div>
            <div>发布人：{{ details.create_by }}</div>
            <div>发布时间：{{ details.create_time }}</div>
          </div>
          <div class="synopsis">
            {{ details.summary }}
          </div>
          <!-- .substring(0, 100) 本想使用截取字符串的方式让文本分开两部分显示-->
          <div v-html="details.content" class="content"></div>
        </div>
        <div class="rightContent">
          <div class="rightTitle">相关文章</div>
          <!--                每一个格子-->
          <div
            :key="index"
            @click="moreArticle(item)"
            class="itemBox"
            v-for="(item, index) in articleData"
          >
            <div class="boxImg">
              <img :src="item.img_host + item.img" width="100%" height="100%" />
            </div>
            <p :title="item.title">{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ["reload"],
  data() {
    return {
      activeName: 1,
      details: {}, //获取到数据详情
      image: this.$baseURL, //图片路径
      articleData: [],
      // sss: 'data:image/svg+xml;base64,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'
    };
  },
  created() {
    this.getdetail();
  },
  watch: {
    $route (to, path) {
      this.getdetail();
    }
  },
  updated() {},
  methods: {
    //跳转至相关详情
    moreArticle(i) {
      this.$router.push({
        path: `/nutritionManagement/managementSon/trainingDetails?type=1&uuid=${i.uuid}&first_cate_uuid=${i.first_cate_uuid}&article_cate_uuid=${i.article_cate_uuid}&sp=1`,
      });
      this.getdetail();
    },
    //获取详情信息
    getdetail(i) {
      this.$axios
        .post("/p/article/read", this.$qs({ uuid: this.$route.query.uuid }))
        .then((res) => {
          if (res.data.code === 0) {
            this.details = res.data.data.data;
            try {
              this.details.content = decodeURI(this.details.content)
                ? decodeURI(this.details.content)
                : this.details.content;
            } catch (err) {
              console.log(err);
            }
          } else {
            this.$message({
              type: "error",
              message: "数据获取失败",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
      //获取所有文章
      this.$axios
        .post(
          "/p/article/lists",
          this.$qs({
            // cate_uuid: this.$route.query.first_cate_uuid,
            cate_uuid:this.$route.query.first_cate_uuid=="undefined"? this.$route.query.article_cate_uuid:this.$route.query.first_cate_uuid
          })
        )
        .then((res) => {
          if (res.data.code === 0) {
            let arr = []; //需要展示的uuid
            let arrData = []; //需要展示的数据
            res.data.data.rows.forEach((item) => {
              if (item.uuid !== this.$route.query.uuid) {
                arr.push(item.uuid);
                arr.forEach((items) => {
                  if (items === item.uuid) {
                    arrData.push(item);
                  }
                });
              }
            });
            this.articleData = arrData;
          } else {
            this.$message({
              type: "error",
              message: "数据获取失败",
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.scrollbarOffset {
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #fff;
}

.wrapBox {
  width: 100%;
  /*height: 100%;*/
  /*overflow: hidden;*/
  margin-top: -40px;
  /*margin-left: 20px;*/

  .leftContent {
    margin-top: 40px;
    padding-left: 30px;
    float: left;
    width: 70%;
    height: 100%;
    padding-right: 40px;
    box-sizing: border-box;
    background-color: #fff;

    .leftContentTitle {
      text-align: center;
      font-size: 26px;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 37px;
      margin-top: 10px;
    }

    .titleContent {
      display: flex;
      justify-content: space-between;
      font-size: 16px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 22px;
      margin-top: 30px;
      padding: 0 40px;

      .titleKeyword {
        width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .synopsis {
      width: 100%;
      height: 50px;
      line-height: 50px;
      background: rgba(242, 242, 242, 1);
      border-radius: 0 4px 4px 0;
      border-left: 6px solid #2493e7;
      box-sizing: border-box;
      padding-left: 20px;
      font-size: 18px;
      color: rgba(153, 153, 153, 1);
      margin-bottom: 36px;
      margin-top: 30px;
    }

    .LeftImg {
      width: 100%;
      height: 600px;
      margin: 30px 0;

      img {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }
  }

  .rightContent {
    padding-top: 60px;
    float: left;
    width: 30%;
    height: 100%;
    padding-left: 60px;
    box-sizing: border-box;
    border-left: 1px solid #e3e3e3;
    background-color: #fff;

    .rightTitle {
      // display: none;
      font-size: 26px;
      font-family: PingFangSC-Medium, PingFangSC;
      font-weight: 500;
      color: rgba(51, 51, 51, 1);
      line-height: 37px;
      margin-bottom: 30px;
    }

    .itemBox {
      width: 80%;
      margin-bottom: 20px;
      padding-bottom: 3px;
      border-radius: 4px;
      overflow: hidden;

      .boxImg {
        width: 100%;
        height: 260px;

        img {
          width: 100%;
          height: 100%;
          overflow: hidden;
        }
      }

      p {
        padding: 0 20px;
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFangSC;
        font-weight: 400;
        line-height: 22px;
        margin: 10px 0 10px 0;
        /*letter-spacing: 4px;*/
        overflow: hidden;
        color: #333;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;

        &:hover {
          color: rgba(36, 147, 231, 1);
          text-decoration: underline;
          /*border-bottom: 1px solid rgba(36, 147, 231, 1);*/
        }
      }

      &:hover {
        box-shadow: 0 2px 8px 0 rgba(189, 189, 189, 1);
        cursor: pointer;
      }
    }
  }
}
/deep/ .text_table {
  position: relative;
  // background-color: aquamarine;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 5px;
  .el-tabs__header {
    margin-bottom: 0;
    .el-tabs__nav-wrap::after {
      background: #fff;
      margin-left: 10px;
      width: 90%;
    }
    .el-tabs__nav {
      height: 55px;
      line-height: 55px;
      font-size: 14px;
    }
    .el-tabs__item {
      font-size: 16px;
      padding: 0 25px;
      &:hover {
        color: #0055e9;
      }
    }
    .is-active {
      color: #0055e9;
    }
    .el-tabs__active-bar {
      background-color: #0055e9;
    }
  }
}

.button_a {
  position: absolute;
  top: 52px;
  left: 15px;
  background-color: #0055e9;
  width: 65px;
  transform: translateX(20.8333px);
  height: 2px;
}
</style>

<style lang="scss">
.leftContent {
  .content {
    img {
      max-width: 100% !important;
    }
  }
}
</style>
